import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=44b3548f&scoped=true"
import script from "./attribute.vue?vue&type=script&lang=js"
export * from "./attribute.vue?vue&type=script&lang=js"
import style0 from "./attribute.vue?vue&type=style&index=0&id=44b3548f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3548f",
  null
  
)

export default component.exports